<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.333 53.333">
  <path d="M26.663.003C11.937.003-.004 11.944-.004 26.669c0 14.726 11.941 26.667 26.667 26.667 14.725 0 26.666-11.941 26.666-26.667C53.33 11.944 41.39.003 26.663.003zm-7.75 40.312H12.42V20.776h6.494zm-3.246-22.207h-.043c-2.179 0-3.588-1.5-3.588-3.375 0-1.917 1.452-3.376 3.673-3.376 2.223 0 3.59 1.46 3.632 3.376 0 1.875-1.409 3.375-3.674 3.375zm26.665 22.207h-6.495V29.86c0-2.626-.94-4.417-3.289-4.417-1.795 0-2.863 1.208-3.332 2.375-.172.417-.215 1-.215 1.585v10.91h-6.493s.085-17.705 0-19.538h6.493v2.767c.864-1.332 2.408-3.226 5.854-3.226 4.273 0 7.477 2.794 7.477 8.795z"/>
</svg>

</template>

<script>
export default {}
</script>
